import styled from "styled-components";

export const DuplicatedInvoicePDF = styled.button`
  all: unset;
  width: 18px;
  height: 18px;
  cursor: pointer;
`;
